/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_PaperbackInputs */

const en_val_paperback = /** @type {(inputs: Val_PaperbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paperback`)
};

const es_val_paperback = /** @type {(inputs: Val_PaperbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tapa blanda`)
};

const fr_val_paperback = /** @type {(inputs: Val_PaperbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Broché`)
};

const de_val_paperback = /** @type {(inputs: Val_PaperbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Taschenbuch`)
};

const ja_val_paperback = /** @type {(inputs: Val_PaperbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ペーパーバック`)
};

const zh_val_paperback = /** @type {(inputs: Val_PaperbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`平装本`)
};

const ar_val_paperback = /** @type {(inputs: Val_PaperbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`غلاف ورقي`)
};

const id_val_paperback = /** @type {(inputs: Val_PaperbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sampul Tipis`)
};

const it_val_paperback = /** @type {(inputs: Val_PaperbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copertina Flessibile`)
};

const ru_val_paperback = /** @type {(inputs: Val_PaperbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Мягкая обложка`)
};

const pt_val_paperback = /** @type {(inputs: Val_PaperbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brochura`)
};

const ko_val_paperback = /** @type {(inputs: Val_PaperbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`문고본 (페이퍼백)`)
};

/**
* | output |
* | --- |
* | "Paperback" |
*
* @param {Val_PaperbackInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_paperback = /** @type {((inputs?: Val_PaperbackInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_PaperbackInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_paperback(inputs)
	if (locale === "es") return es_val_paperback(inputs)
	if (locale === "fr") return fr_val_paperback(inputs)
	if (locale === "de") return de_val_paperback(inputs)
	if (locale === "ja") return ja_val_paperback(inputs)
	if (locale === "zh") return zh_val_paperback(inputs)
	if (locale === "ar") return ar_val_paperback(inputs)
	if (locale === "id") return id_val_paperback(inputs)
	if (locale === "it") return it_val_paperback(inputs)
	if (locale === "ru") return ru_val_paperback(inputs)
	if (locale === "pt") return pt_val_paperback(inputs)
	return ko_val_paperback(inputs)
});